namespace $.$$ {

	$mol_style_define( $shm_tests_app_run, {

		height: '100%',
		minHeight: 0,

		Head: {
			justify: {
				content: 'flex-start',
			},
			align: {
				items: 'center',
			},
		},

		Title: {
			flex: {
				grow: 0,
			},
		},

		Body: {
			minHeight: 0,
		},

		Header_controls: {
			align: {
				items: 'center',
			},
		},

		Body_content: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
			padding: $mol_gap.block,
			width: '100%',
		},

		Artifacts: {
			flex: {
				direction: 'column',
			},
		},

		Artifacts_title: {
			font: {
				weight: 'bold',
			},
		},

	} )

}
